import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/MyPortifolio">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
